"use client";

import { useParams, usePathname } from "next/navigation";
import { useMemo } from "react";

type RegionCountry = {
  region: string;
  countries: {
    name: string;
    code_slug: string;
  }[];
};

const useCountryPages = (regionCountries: RegionCountry[] = []) => {
  const pathname = usePathname();
  const { country } = useParams<{ country?: string }>();

  const newCountries = useMemo(() => {
    if (!regionCountries.length) return [];
    // collect all country codes across regions
    const allCountryCodes = regionCountries.flatMap((r) =>
      r.countries.map((c) => c.code_slug)
    );
    return regionCountries.map((item) => {
      const modifiedCountries = item.countries.map((country) => {
        let url = pathname;
        const hasTrailingSlash = pathname.endsWith("/");
        if (/courses|course|topic/.test(pathname)) {
          const parts = pathname.split("/").filter(Boolean);

          if (allCountryCodes.includes(parts[0])) {
            // replace existing country code
            parts[0] = country.code_slug;
          } else {
            // prepend if no country code
            parts.unshift(country.code_slug);
          }

          url = "/" + parts.join("/") + (hasTrailingSlash ? "/" : "");
        } else {
          url = "/" + country.code_slug + (hasTrailingSlash ? "/" : "");
        }

        return {
          ...country,
          url,
        };
      });

      return { region: item.region, countries: modifiedCountries };
    });
  }, [regionCountries, country]);

  return { countries: newCountries };
};

export default useCountryPages;
